import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MaterialModule } from 'app/material.module';
import { SharedModule } from 'app/shared/shared.module';
import { WebcamModule } from 'ngx-webcam';
import { DoctorDashboardComponent } from './doctor-dashboard/doctor-dashboard.component';
import { ChartsModule } from 'ng2-charts';
import {MatDatepickerModule} from '@angular/material/datepicker';


@NgModule({
  declarations: [
    DoctorDashboardComponent
  ],
  imports: [
    WebcamModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    MatFormFieldModule,
    ChartsModule,
    MatDatepickerModule
  ]
})
export class DoctorDashboardModule { }
